import { useQuery } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';
import { STAFF_SUBNETS } from '@scio3/graphql-client';
import type { Subnet } from '@scio3/shared-types';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@scio3/ui';
import { SubnetRow } from '../components/SubnetRow';

export function SubnetsPage() {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery<{ staffSubnets: Subnet[] }>(STAFF_SUBNETS, {
    fetchPolicy: 'cache-and-network',
  });
  const subnets = data?.staffSubnets ?? [];

  return (
    <div className="flex flex-col gap-6 p-6" data-testid="subnets-page">
      <div>
        <h1 className="text-2xl font-bold text-foreground">{t('Network / Subnets')}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('Source: deploy/config/network.yaml (git). Read-only.')}
        </p>
      </div>

      {error ? (
        <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
          {error.message}
        </div>
      ) : loading && !subnets.length ? (
        <div className="text-sm text-muted-foreground">{t('Loading subnets…')}</div>
      ) : (
        <div className="rounded-lg border bg-card">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t('Name')}</TableHead>
                <TableHead>{t('CIDR / Range')}</TableHead>
                <TableHead>{t('Type')}</TableHead>
                <TableHead>{t('Provisioner?')}</TableHead>
                <TableHead>{t('Usage')}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {subnets.map((subnet) => (
                <SubnetRow key={subnet.name} subnet={subnet} />
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
